import type { WebPlaySettings } from '../types'

export function parseCompletionKeywords(webPlayInfoResp: WebPlaySettings) {
  if (!webPlayInfoResp.completionKeywords) {
    return null
  }
  if (webPlayInfoResp.enableFunnelView) {
    return null
  }
  const tags = webPlayInfoResp.completionKeywords
    .split(';')
    .map((x: string) => (x ? x.trim().toLowerCase() : null))
    .filter((x: string | null) => x)
  return new Set(tags)
}

export function checkCompletionKeywords(
  actualKeywords: string[] | null,
  completionKeywords: Set<string | null> | null,
) {
  return (
    !completionKeywords ||
    !completionKeywords.size ||
    (actualKeywords && actualKeywords.length > 0 && actualKeywords.some(x => completionKeywords.has(x.toLowerCase())))
  )
}
